// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as PlayComponent} from './Play.svg';

import Icon, { TIconProps } from '../Icon';

export const IconPlay = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <PlayComponent/>
  </Icon>
));
